import React from 'react'

const ThirdPartyInspectionServices = () => {
  return (
    <section className="services-details pt-120 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          {/*Start Services Details Content*/}
          <div className="col-xl-12 col-lg-12">
            <div className="services-details__content">
              <h3>Third-Party Inspection Services </h3>
              <p className="mb-30">
                Third-Party Inspection (TPI) is a critical service for ensuring
                quality, compliance, and safety across industrial, construction,
                and infrastructure projects. It provides independent
                verification of products, materials, equipment, and construction
                work, confirming that they meet design specifications,
                contractual requirements, and regulatory standards.
              </p>
              <p className="mb-30">
                The need for third-party inspection arises from risks such as
                conflicts of interest, substandard materials, construction
                defects, and regulatory non-compliance. By engaging an
                independent inspection company, organizations gain objective
                assessments, reduce operational risks, and ensure accountability
                in their projects.
              </p>
              <p className="mb-30">
                Without third-party inspection, projects may face quality
                disputes, safety incidents, costly rework, and reputational
                damage.
              </p>
              <div className="content mt-40">
                <div className="text">
                  <h3 className="mb-4">Purpose and Importance</h3>
                  <p className="mb-30">
                    The primary goal of third-party inspection is to provide
                    <b>
                      independent verification, monitoring, and documentation
                    </b>{" "}
                    of materials, equipment, and processes.
                  </p>
                  <p className="mb-30">Benefits include:</p>
                  <ul className="project-list">
                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Ensuring compliance with design, contractual, and
                      regulatory requirements
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Detecting defects and non-conformities at an early stage
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Enhancing transparency and credibility in quality
                      assurance processes
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Supporting certification, acceptance, and project handover
                      processes
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Reducing rework, operational risks, and project delays
                    </li>
                  </ul>
                  <p className="mb-30">
                    Third-party inspection instills confidence in stakeholders
                    and ensures that projects are delivered to the highest
                    quality standards.
                  </p>
                </div>
              </div>
              <div className="service-nr-list">
                <h3 className="mb-5">Our Services </h3>
                <p className="mb-30">
                  Pak Arab Inspection LTD. CO Company provides comprehensive third-party
                  inspection services for industrial, oil & gas, construction,
                  infrastructure, and manufacturing projects. We function as an
                  independent, objective partner, ensuring all inspection
                  activities comply with international standards and client
                  requirements.
                </p>
                <p className="mb-30">
                  Our team of certified inspectors delivers correct, unbiased
                  reports that support engineering decisions, regulatory
                  compliance, and contractual obligations.
                </p>
              </div>
              <div className="service-nr-list">
                <h3 className="">Scope </h3>
                <h4 className="">Our TPI services typically include:</h4>
                <div className="row">
                  <div className="col-lg-4">
                    <h5>Pre-Production and Manufacturing Inspection</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Material Verification and
                        Certification Checks.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Dimensional and Visual
                        Inspection of Components.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Verification of Welding,
                        Fabrication, and Assembly Quality.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Raw Material Testing and
                        Compliance Review.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>During Construction or Installation</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> On-Site Supervision and
                        Inspection.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Welding, Bolting, and
                        Structural Integrity Checks.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Pressure Testing, Leak
                        Testing, and Commissioning Inspections.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Compliance Verification
                        with Approved Drawings and Specifications.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Post-Production / Pre-Shipment</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Final Product Inspection
                        and Certification.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Packaging, Labeling, and
                        Documentation Verification.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Witnessing Factory
                        Acceptance Tests (FAT) and Performance Tests.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ThirdPartyInspectionServices